export function adjacentFromOppositeAngle(opposite, radians) {
    return opposite / Math.tan(radians);
}
export function deg2rad(degrees) {
    return degrees * Math.PI / 180;
}
export function rad2deg(radians) {
    return radians * 180 / Math.PI;
}
